import {CONSONANT_VOWEL_PAIRS_D_T} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_dt";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_D_T_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_D_T} title="Consonant-Vowel Pairs: ㄷ (d/t)" />
     </>
);}